// The card of a spell over the board, before it is cast: the full card, what
// it costs, and two keys, Back and Cast. A press on a slot opens it, on a phone
// and in a wide window. On a phone the card has the room of the board and not
// the strip under it. Garrett, 2026-10-14: "We need to have the card come up
// above the board here on mobile so it's not all scrunched in this container",
// and "I need a way to confirm I'm playing this upgrade". See
// `state/castChoice.ts`. The words are plain placeholders.

import { slotsOf } from '../game/casters';
import { el } from '../lib/dom';
import { castChoiceStore, confirmCast, dismissCast } from '../state/castChoice';
import { gameStore } from '../state/game';
import { createSpellCardFace } from './SpellCardFace';

const BACK_LABEL = 'Back';
const CAST_LABEL = 'Cast';

export const createCastSheet = (): HTMLElement => {
  const card = createSpellCardFace('cast-sheet__card');
  const price = el('p', { className: 'cast-sheet__price' });
  const back = el('button', {
    className: 'button button--pass-through cast-sheet__back',
    type: 'button',
    textContent: BACK_LABEL,
    onclick: dismissCast,
  });
  const cast = el('button', {
    className: 'button cast-sheet__cast',
    type: 'button',
    textContent: CAST_LABEL,
    onclick: confirmCast,
  });
  const panel = el('div', { className: 'cast-sheet__panel' }, [
    card.root,
    price,
    el('div', { className: 'cast-sheet__keys' }, [back, cast]),
  ]);
  const root = el('div', { className: 'cast-sheet', hidden: true }, [panel]);
  // A press on the dim board around the card is Back.
  root.addEventListener('click', (event) => {
    if (event.target === root) dismissCast();
  });

  const draw = (choice: number | null): void => {
    const state = gameStore.get();
    const slot = choice === null ? undefined : slotsOf(state, state.turn)[choice];
    root.hidden = !slot?.spellId;
    if (!slot?.spellId) return;
    card.draw({ spellId: slot.spellId, caster: null }, '');
    price.textContent = slot.kind === 'scroll' ? 'Uses the scroll' : `Costs ${slot.cost} energy`;
    cast.focus({ preventScroll: true });
  };

  castChoiceStore.subscribe(draw);
  return root;
};
